export default {
  setCurrentPatient (context, payload) {
    context.commit('setCurrentPatient', payload)
  }
}
